import { render, staticRenderFns } from "./LocationsMap.vue?vue&type=template&id=0a56a404&scoped=true"
import script from "./LocationsMap.vue?vue&type=script&lang=js"
export * from "./LocationsMap.vue?vue&type=script&lang=js"
import style0 from "./LocationsMap.vue?vue&type=style&index=0&id=0a56a404&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a56a404",
  null
  
)

export default component.exports